/**
 * Public page paths owned by the My application.
 *
 * Keep cross-application redirects pointed at these constants so route changes
 * are coordinated from the owning domain.
 */
export const myPagePaths = {
  accountSettings: '/settings/account',
} as const;
